<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Create Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    :format="dateFormat"
                  />
                </div>
                <!-- <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    initialValue="proyek"
                    allowClear
                  >
                    <a-select-option value="Project">Project</a-select-option>
                    <a-select-option value="Non Project"
                      >Non Project</a-select-option
                    >
                  </a-select>
                </div> -->
                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="transferred"
                      >Transferred</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Payment Instruction List"
        createLink="CreatePi"
        manifestLink="PiManifest"
        editLink="EditPi"
        :dataList="piSearch"
        :isTransactional="true"
        :allowcancel="true"
        :disabledCreateEditLink="true"
      />
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListPI",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      piList: [],
      search: "",
      tempList: "",
      //kategori: "",
      status: "",
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    piSearch: function () {
      var self = this;
      let searchingOutput = this.piList;

      if (this.search) {
        searchingOutput = _.filter(
          searchingOutput,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      // if (this.kategori) {
      //   if (self.kategori === "Project") {
      //     searchingOutput = _.filter(
      //       searchingOutput,
      //       (item) => item.peruntukan !== "Non Project"
      //     );
      //   } else {
      //     searchingOutput = _.filter(searchingOutput, {
      //       peruntukan: "Non Project",
      //     });
      //   }
      // }

      if (this.status) {
        searchingOutput = _.filter(
          searchingOutput,
          (item) => item.status.toLowerCase() === self.status.toLowerCase()
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        // searchingOutput = _.filter(
        //   searchingOutput,
        //   (obj) => moment(obj.tgl_buat).isBetween(startDt,endDt) ||
        //   moment(obj.tgl_buat).isSameOrAfter(startDt, 'day')
        // );

        searchingOutput = _.filter(
          searchingOutput,
          (obj) =>
            moment(obj.tgl_buat).format(this.getStandartFormatDate) >=
              startDt &&
            moment(obj.tgl_buat).format(this.getStandartFormatDate) <= endDt
        );
      }

      return searchingOutput;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "pi",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            const date = data.tgl_buat;
            this.piList.push({
              title: data.no,
              subtitle: { deskripsi: data.deskripsi },
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: date,
                    value: "",
                  },
                ],
                [
                  {
                    label: "TLC Create",
                    value: data.tlc_pembuat,
                  },
                ],
                [
                  {
                    label: "Value",
                    value:
                      data.realisasi == "0"
                        ? "There are no reports yet"
                        : this.formatCurrency(
                            data.currency,
                            data.total_pemakaian
                          ),
                  },
                ],
              ],
              status: data.status,
              id: data.id_manifest,
              tgl_buat: data.tgl_buat,
              peruntukan: data.peruntukan,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              searchQ:
                data.deskripsi+" "+data.no + " " + data.tlc_pembuat + " " + data.total_pemakaian,
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "umpp",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>